<template>
    <v-container grid-list-sm fluid class="prod-bg">
        <div v-show="loading" style="text-align: center; padding: 25px 0; padding-bottom: 0;">
            <inline-loader></inline-loader>
        </div>
        <div class="product-item">
            <div class="product-item__content" v-for="product in products.data" :key="product.id">
                <div class="product-item__img" @click="redirectToProduct(product.id)">
                    <v-img :src="product.primary_image" lazy-src="https://digima.sgp1.digitaloceanspaces.com/mybarko/item-placeholder.svg" contain aspect-ratio="1.2"></v-img>
                    <!-- <sale-tag v-if="product.primary_image != ''"> -->
                        <!-- <div class="percent">{{ product.id }}%</div> -->
                        <!-- <div class="off">OFF</div> -->
                    <!-- </sale-tag> -->
                </div>
                <div class="product-item__details">
                    <div class="product-item__details-name substr">{{ product.name }}</div>
                    <div class="product-item__details-price">
                        <div class="sale">{{product.price_range}}</div>
                        <div class="prev-price" v-if="product.price_range == ''">P 50.00</div>
                    </div>
                </div>
                <!-- <div class="product-item__rating"> -->
                    <!-- <heart></heart> -->
                    <!-- <rating-star :rating="product.id"></rating-star> -->
                <!-- </div> -->
            </div>
        </div>
    </v-container>
</template>

<script>

import {storeProducts} from "../storeProducts";

export default {
    data() {
        return {
            products: [],
            loading: false,
        }
    },
    props: {
        shopId : {
            default : ''
        }
    },
    methods: {
        redirectToProduct (id) {
            this.$router.push(
                {
                    path: '/product/'+id,
                }
            )
        },
        async getList(){
            if (storeProducts.state.products !== null){
                this.products = storeProducts.state.products;
                return;
            }

            this.loading = true
            await axios.get(`/api/g/product?page=1&limit=6&shopId=${this.shopId}`)
                .then(response => {
                    this.products = response.data.data
                    this.products.data.forEach((data,key) =>
                    {
                        if (data.galleries.length)
                        {
                            this.products.data[key].primary_image = data.galleries[0].url_optimized
                        }
                        else
                        {
                            this.products.data[key].primary_image = ""
                        }
                        this.products.data[key].price_range = this.getPriceRange(data.variations)
                    })
                })
                .catch(err => {
                    if (err.response.data.message === "Server Error"){
                        this.getList();
                        return;
                    }
                })
                .finally(()=> {
                    this.loading = false
                });


            storeProducts.commit('store_products', this.products);
        },
        getPriceRange(array)
        {
            if (array.length)
            {
                var min = array[0].price,
                    max = array[0].price;

                var range = null;

                array.map((response)=>
                {
                    min = response.price < min ? response.price : min
                    max = response.price > max ? response.price : max
                });

                min = Number.parseFloat(min).toFixed(2);
                max = Number.parseFloat(max).toFixed(2);

                if(min == max)
                {
                    return  "P " + this.numberWithCommas(min);
                }
                return "P "+ this.numberWithCommas(min) + " - P "+ this.numberWithCommas(max);
            }
            return "P " + "0.00";
        },
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

    },
    mounted() {

        this.getList()

    }
}
</script>

<style lang="scss">
@import "../scss/app";
</style>
